export enum FooterType {
  Event = "event",
  Page = "page",
  Article = "article",
  Subcategory = "subcategory", // tournament
  Performer = "performer", // team
  Custom = "custom",
  Separator = "separator",
  Text = "text",
  Icon = "icon",
}

export default "./index.svelte";
